module.exports = __webpack_public_path__ + "static/media/marcela.99015f0b.jpg";